import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Home from '@/components/Home'

import NotFound from '@/components/404'

import Kategori from '@/components/master/Kategori'
import KategoriForm from '@/components/master/KategoriForm'
import BahanBaku from '@/components/master/BahanBaku'
import BahanBakuForm from '@/components/master/BahanBakuForm'
import Menu from '@/components/master/Menu'
import MenuForm from '@/components/master/MenuForm'
import Meja from '@/components/master/Meja'
import MejaForm from '@/components/master/MejaForm'
import Supplier from '@/components/master/Supplier'
import SupplierForm from '@/components/master/SupplierForm'

import Penjualan from '@/components/laporan/Penjualan'
import PenjualanDetail from '@/components/laporan/PenjualanDetail'
import TipePembayaran from '@/components/laporan/TipePembayaran'
import OjekOnline from '@/components/laporan/OjekOnline'
import Diskon from '@/components/laporan/Diskon'
import Pajak from '@/components/laporan/Pajak'
import Hpp from '@/components/laporan/Hpp'
import MenuFavorit from '@/components/laporan/MenuFavorit'
import TrafficPelanggan from '@/components/laporan/TrafficPelanggan'

import ProdukTerlaris from '@/components/laporan/ProdukTerlaris'
import PurchaseOrder from '@/components/laporan/PurchaseOrder'
import PurchaseOrderHarian from '@/components/laporan/PurchaseOrderHarian'
import LabaRugi from '@/components/laporan/LabaRugi'
import LaporanPaidInOut from '@/components/laporan/PaidInOut'

import LaporanPembelian from '@/components/laporan/Pembelian'

import StokMasuk from '@/components/stok/StokMasuk'
import StokKeluar from '@/components/stok/StokKeluar'
import PenyesuaianStok from '@/components/stok/PenyesuaianStok'
import PenyesuaianStokForm from '@/components/stok/PenyesuaianStokForm'
import SemuaStok from '@/components/stok/SemuaStok'
import DetailStok from '@/components/stok/DetailStok'

import GajiKaryawan from '@/components/transaksi/GajiKaryawan'
import GajiKaryawanForm from '@/components/transaksi/GajiKaryawanForm'
import Pembelian from '@/components/transaksi/Pembelian'
import PembelianForm from '@/components/transaksi/PembelianForm'

import Setting from '@/components/Setting'
import Toko from '@/components/Pengaturan/Toko.vue'
import Outlet from '@/components/Pengaturan/Outlet.vue'
import OutletForm from '@/components/Pengaturan/OutletForm.vue'
import User from '@/components/Pengaturan/User.vue'
import UserForm from '@/components/Pengaturan/UserForm.vue'
import HakAkses from '@/components/Pengaturan/HakAkses'
import HakAksesForm from '@/components/Pengaturan/HakAksesForm'

import Forbidden from '@/components/forbidden'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/',
      name: 'Home',
      component: Home
    },

    { path: '/404', component: NotFound },
    { path: '*', redirect: '/404' },

    {
      path: '/master/kategori',
      name: 'Kategori',
      component: Kategori
    },
    {
      path: '/master/kategori/:id',
      name: 'KategoriForm',
      component: KategoriForm
    },
    {
      path: '/master/bahan-baku',
      name: 'BahanBaku',
      component: BahanBaku
    },
    {
      path: '/master/bahan-baku/:id',
      name: 'BahanBakuForm',
      component: BahanBakuForm
    },
    {
      path: '/master/menu',
      name: 'Menu',
      component: Menu
    },
    {
      path: '/master/menu/:id',
      name: 'MenuForm',
      component: MenuForm
    },
    {
      path: '/master/meja',
      name: 'Meja',
      component: Meja
    },
    {
      path: '/master/meja/:id',
      name: 'MejaForm',
      component: MejaForm
    },
    {
      path: '/master/supplier',
      name: 'Supplier',
      component: Supplier
    },
    {
      path: '/master/supplier/:id',
      name: 'SupplierForm',
      component: SupplierForm
    },

    {
      path: '/laporan/penjualan',
      name: 'Laporan Penjualan',
      component: Penjualan
    },
    {
      path: '/laporan/penjualan/detail/:id',
      name: 'Laporan Penjualan Detail',
      component: PenjualanDetail
    },
    {
      path: '/laporan/penjualan/tipe-pembayaran',
      name: 'Laporan Penjualan Per Tipe Pembayaran',
      component: TipePembayaran
    },
    {
      path: '/laporan/penjualan/ojek-online',
      name: 'Laporan Penjualan Per Ojek Online',
      component: OjekOnline
    },
    {
      path: '/laporan/penjualan/diskon',
      name: 'Laporan Diskon',
      component: Diskon
    },
    {
      path: '/laporan/penjualan/pajak',
      name: 'Laporan Pajak',
      component: Pajak
    },
    {
      path: '/laporan/penjualan/hpp',
      name: 'Laporan Hpp',
      component: Hpp
    },
    {
      path: '/laporan/penjualan/menu-favorit',
      name: 'Laporan Menu Favorit',
      component: MenuFavorit
    },
    {
      path: '/laporan/penjualan/traffic-customer',
      name: 'Laporan Traffic Pelanggan',
      component: TrafficPelanggan
    },
    {
      path: '/laporan/produk-terlaris',
      name: 'Laporan Produk Terlaris',
      component: ProdukTerlaris
    },
    {
      path: '/laporan/purchase-order',
      name: 'Laporan Purchase Order',
      component: PurchaseOrder
    },
    {
      path: '/laporan/purchase-order-harian',
      name: 'Purchase Order Harian',
      component: PurchaseOrderHarian
    },
    {
      path: '/laporan/laba-rugi',
      name: 'Laporan Laba Rugi',
      component: LabaRugi
    },
    {
      path: '/laporan/paid-in-out',
      name: 'Laporan Paid In Paid Out',
      component: LaporanPaidInOut
    },
    {
      path: '/laporan/pembelian/:status',
      name: 'LaporanPembelian',
      component: LaporanPembelian
    },
    {
      path: '/transaksi/gaji',
      name: 'GajiKaryawan',
      component: GajiKaryawan
    },
    {
      path: '/transaksi/gaji/:id',
      name: 'GajiKaryawanForm',
      component: GajiKaryawanForm
    },
    {
      path: '/transaksi/pembelian',
      name: 'Pembelian',
      component: Pembelian
    },
    {
      path: '/transaksi/pembelian/:id',
      name: 'Pembelian',
      component: PembelianForm
    },
    {
      path: '/inventory/stok-masuk',
      name: 'StokMasuk',
      component: StokMasuk
    },
    {
      path: '/inventory/stok-keluar',
      name: 'StokKeluar',
      component: StokKeluar
    },
    {
      path: '/inventory/penyesuaian-stok',
      name: 'PenyesuaianStok',
      component: PenyesuaianStok
    },
    {
      path: '/inventory/penyesuaian-stok/:id',
      name: 'PenyesuaianStokForm',
      component: PenyesuaianStokForm
    },
    {
      path: '/inventory/stok',
      name: 'Stok',
      component: SemuaStok
    },
    {
      path: '/inventory/detail/:id',
      name: 'DetailStok',
      component: DetailStok
    },
    {
      path: '/setting',
      name: 'Setting',
      component: Setting
    },
    {
      path: '/pengaturan/toko',
      name: 'Toko',
      component: Toko
    },
    {
      path: '/pengaturan/outlet',
      name: 'Outlet',
      component: Outlet
    },
    {
      path: '/pengaturan/outlet/:id',
      name: 'OutletForm',
      component: OutletForm
    },
    {
      path: '/pengaturan/user',
      name: 'User',
      component: User
    },
    {
      path: '/pengaturan/user/:id',
      name: 'User Form',
      component: UserForm
    },
    {
      path: '/pengaturan/hak-akses',
      name: 'HakAkses',
      component: HakAkses
    },
    {
      path: '/pengaturan/hak-akses/:id',
      name: 'HakAkses',
      component: HakAksesForm
    },
    {
      path: '/forbidden',
      name: 'Forbidden',
      component: Forbidden
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js